// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"bf11238a","81":"92d0654e","84":"ea728717","297":"d13108f6","411":"91997d1f","449":"2ccf19c9","650":"44f71676","787":"9b509a63","835":"5ab34612","895":"b845fd3a"}[chunkId] + ".chunk.js";
};